function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["allowPastDates", "bodyProps", "calendarIconButtonProps", "calendarProps", "className", "closeButtonProps", "closeOnClickAway", "closeOnSelection", "columnHeaderProps", "defaultOpen", "defaultSelectedDate", "dialogProps", "disabled", "error", "errorPosition", "errorProps", "focusLock", "focusLockProps", "gridCellProps", "gridProps", "headerProps", "headingProps", "helpText", "helpTextProps", "id", "innerProps", "labelPosition", "labelProps", "labels", "locale", "look", "max", "maxLength", "min", "minLength", "name", "nextMonthButtonProps", "onBlur", "onChange", "onClose", "onOpen", "onSelection", "pattern", "previousMonthButtonProps", "readOnly", "required", "rowProps", "showCloseButton", "showLabel", "tbodyProps", "textfieldProps", "theadProps", "todayProps", "transitionDelay", "transitionDuration", "useLayerOptions", "wrapperRef"],
  _excluded2 = ["ref", "style"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useState, useRef, useEffect } from 'react';
import FocusLock from 'react-focus-lock';
import { useLayer } from 'react-laag';
import { Transition } from 'react-transition-group';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import { ButtonLooks } from "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import { DatePickerPlacements } from "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import { FontIcons } from "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputErrorPositions, InputLabelPositions } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import { getContainer } from "../../../../utilities/container.js";
import { convertToDate, formatDate, validateDate, beforeDate, todayDate, generateCalendar, generateColumns, sameDay, addMonth, subMonth, sameMonth, addDay, addWeek, addYear, subDay, subWeek, subYear, endWeek, startWeek } from "../../../../utilities/date.js";
import { getInputFormatLocale } from "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { usePrefersReducedMotion } from "../../../../hooks/use-prefers-reduced-motion.js";
import "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import 'styled-components';
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { transitionFadeIn } from "../../../../styles/transitions/fade-in.js";
import "../../../atoms/icon/font-icon/font-icon.js";
import "../../../atoms/alert/inline-alert/inline-alert.js";
import "../../../atoms/alert/standard-alert/standard-alert.js";
import 'boring-avatars';
import "../../../atoms/tooltip/hover-tooltip/hover-tooltip.js";
import '@brandfolder/utilities';
import { CloseButton } from "../../../atoms/button/close-button/close-button.js";
import "../../../atoms/button/color-button/color-button.js";
import { IconButton } from "../../../atoms/button/icon-button/icon-button.js";
import "../../../atoms/button/standard-button/standard-button.js";
import "../../../atoms/loader/circle-loader/circle-loader.js";
import "../../../atoms/loader/shimmer-loader/shimmer-loader.js";
import "../../../atoms/divider/standard-divider/standard-divider.js";
import "../../../atoms/fieldset/standard-fieldset/standard-fieldset.js";
import "../../../atoms/heading/standard-heading/standard-heading.js";
import "../../../atoms/label/standard-label/standard-label.js";
import "../../../atoms/link/button-link/button-link.js";
import "../../../atoms/link/standard-link/standard-link.js";
import "../../../atoms/popout/standard-popout/standard-popout.js";
import "../../../atoms/screen-reader/only-for-screen-reader/only-for-screen-reader.js";
import "../../../atoms/table/standard-table/caption.js";
import "../../../atoms/table/standard-table/tbody.js";
import "../../../atoms/table/standard-table/tr-empty.js";
import "../../../atoms/table/standard-table/td.js";
import "../../../atoms/table/standard-table/tr.js";
import "../../../atoms/table/standard-table/table.js";
import "../../../atoms/table/standard-table/tfoot.js";
import "../../../atoms/table/standard-table/th.js";
import "../../../atoms/table/standard-table/thead.js";
import "../../../atoms/table/dnd-table/dnd-handle-td.js";
import "../../../atoms/table/dnd-table/dnd-table-drag-context.js";
import "../../../atoms/text/help-text/help-text.js";
import "../../../atoms/text/standard-text/standard-text.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import { TextfieldInner } from "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseTextfield } from "../../textfield/base-textfield/base-textfield.js";
import "../../textfield/standard-textfield/standard-textfield.js";
import { BaseColumnHeader } from "./base-column-header.js";
import { BaseGridCell } from "./base-grid-cell.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseDatePicker = /*#__PURE__*/forwardRef(function (props, ref) {
  var _navigator, _classnames13;
  var _props$allowPastDates = props.allowPastDates,
    allowPastDates = _props$allowPastDates === void 0 ? true : _props$allowPastDates,
    bodyProps = props.bodyProps,
    calendarIconButtonProps = props.calendarIconButtonProps,
    calendarProps = props.calendarProps,
    className = props.className,
    closeButtonProps = props.closeButtonProps,
    _props$closeOnClickAw = props.closeOnClickAway,
    closeOnClickAway = _props$closeOnClickAw === void 0 ? true : _props$closeOnClickAw,
    _props$closeOnSelecti = props.closeOnSelection,
    closeOnSelection = _props$closeOnSelecti === void 0 ? true : _props$closeOnSelecti,
    columnHeaderProps = props.columnHeaderProps,
    _props$defaultOpen = props.defaultOpen,
    defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
    defaultSelectedDate = props.defaultSelectedDate,
    dialogProps = props.dialogProps,
    disabled = props.disabled,
    externalError = props.error,
    _props$errorPosition = props.errorPosition,
    errorPosition = _props$errorPosition === void 0 ? InputErrorPositions.Bottom : _props$errorPosition,
    errorProps = props.errorProps,
    _props$focusLock = props.focusLock,
    focusLock = _props$focusLock === void 0 ? true : _props$focusLock,
    focusLockProps = props.focusLockProps,
    gridCellProps = props.gridCellProps,
    gridProps = props.gridProps,
    headerProps = props.headerProps,
    headingProps = props.headingProps,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    innerProps = props.innerProps,
    _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    labelProps = props.labelProps,
    labels = props.labels,
    _props$locale = props.locale,
    defaultLocale = _props$locale === void 0 ? ((_navigator = navigator) === null || _navigator === void 0 ? void 0 : _navigator.language) || '' : _props$locale,
    look = props.look,
    max = props.max,
    maxLength = props.maxLength,
    min = props.min,
    minLength = props.minLength,
    name = props.name,
    nextMonthButtonProps = props.nextMonthButtonProps,
    _onBlur = props.onBlur,
    _onChange = props.onChange,
    onClose = props.onClose,
    onOpen = props.onOpen,
    onSelection = props.onSelection,
    pattern = props.pattern,
    previousMonthButtonProps = props.previousMonthButtonProps,
    readOnly = props.readOnly,
    required = props.required,
    rowProps = props.rowProps,
    _props$showCloseButto = props.showCloseButton,
    showCloseButton = _props$showCloseButto === void 0 ? false : _props$showCloseButto,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? false : _props$showLabel,
    tbodyProps = props.tbodyProps,
    textfieldProps = props.textfieldProps,
    theadProps = props.theadProps,
    todayProps = props.todayProps,
    _props$transitionDela = props.transitionDelay,
    transitionDelay = _props$transitionDela === void 0 ? 0 : _props$transitionDela,
    _props$transitionDura = props.transitionDuration,
    transitionDuration = _props$transitionDura === void 0 ? 200 : _props$transitionDura,
    useLayerOptions = props.useLayerOptions,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var changeDate = labels.changeDate,
    chooseDate = labels.chooseDate,
    closeButton = labels.closeButton,
    invalidDateError = labels.invalidDateError,
    label = labels.label,
    nextMonthButton = labels.nextMonthButton,
    pastDateError = labels.pastDateError,
    previousMonthButton = labels.previousMonthButton,
    requiredLabel = labels.requiredLabel;
  var now = new Date();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    calendar = _useState2[0],
    setCalendar = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    columns = _useState4[0],
    setColumns = _useState4[1];
  var _useState5 = useState(now),
    _useState6 = _slicedToArray(_useState5, 2),
    currentDate = _useState6[0],
    setCurrentDate = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    internalError = _useState8[0],
    setInternalError = _useState8[1];
  var _useState9 = useState(convertToDate(defaultSelectedDate)),
    _useState10 = _slicedToArray(_useState9, 2),
    initialDate = _useState10[0],
    setInitialDate = _useState10[1];
  var _useState11 = useState(getInputFormatLocale(defaultLocale)),
    _useState12 = _slicedToArray(_useState11, 2),
    locale = _useState12[0],
    setLocale = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    mounted = _useState14[0],
    setMounted = _useState14[1];
  var _useState15 = useState(defaultOpen || false),
    _useState16 = _slicedToArray(_useState15, 2),
    open = _useState16[0],
    setOpen = _useState16[1];
  var _useState17 = useState(null),
    _useState18 = _slicedToArray(_useState17, 2),
    selectedDate = _useState18[0],
    setSelectedDate = _useState18[1];
  var _useState19 = useState(''),
    _useState20 = _slicedToArray(_useState19, 2),
    value = _useState20[0],
    setValue = _useState20[1];
  var error = externalError || internalError || '';
  var hasError = !!externalError || !!internalError;
  var hasHelpText = !!helpText;
  var hasRequired = required && !!requiredLabel;
  var calendarIconButtonId = "".concat(id, "-calendar-icon-button");
  var dialogId = "".concat(id, "-dialog");
  var headingId = "".concat(id, "-heading");
  var helpTextId = "".concat(id, "-help-text");
  var inlineAlertId = "".concat(id, "-inline-alert");
  var wrapperId = "".concat(id, "-wrapper");
  var timeout = transitionDelay ? transitionDelay + transitionDuration : transitionDuration;
  var calendarIconButtonRef = useRef(null);
  var currentDateRef = useRef(null);
  var nodeRef = useRef(null);
  var prefersReducedMotion = usePrefersReducedMotion();
  var handleClose = function handleClose() {
    var focusCalendarIconButton = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    setOpen(false);
    // when closing, the focus needs to return to the calendar icon button
    if (focusCalendarIconButton && calendarIconButtonRef.current) {
      // this is a little hacky but required
      // focusing on this ref has a timing conflict with onKeyDown below
      // causing the calendar to reopen after being closed on selection
      // so we need a little delay before focusing
      setTimeout(function () {
        var _calendarIconButtonRe;
        (_calendarIconButtonRe = calendarIconButtonRef.current) === null || _calendarIconButtonRe === void 0 || _calendarIconButtonRe.focus();
      }, 100);
    }
    if (onClose) onClose();
  };
  var handleOpen = function handleOpen() {
    setOpen(true);
    if (onOpen) onOpen();
  };
  var handleFuture = function handleFuture(date) {
    if (!allowPastDates && initialDate && beforeDate(date, now) && !todayDate(date)) {
      return now;
    }
    return date;
  };
  var handleNextDay = function handleNextDay() {
    return setCurrentDate(handleFuture(addDay(currentDate)));
  };
  var handleNextMonth = function handleNextMonth() {
    return setCurrentDate(handleFuture(addMonth(currentDate)));
  };
  var handleNextWeek = function handleNextWeek() {
    return setCurrentDate(handleFuture(addWeek(currentDate)));
  };
  var handleNextYear = function handleNextYear() {
    return setCurrentDate(handleFuture(addYear(currentDate)));
  };
  var disablePreviousMonth = function disablePreviousMonth() {
    if (!allowPastDates && initialDate) {
      return beforeDate(initialDate, now) ? beforeDate(subMonth(currentDate), initialDate) && sameMonth(currentDate, initialDate) : sameMonth(currentDate, now);
    }
    if (!allowPastDates && !initialDate) {
      return beforeDate(subMonth(currentDate), now) && sameMonth(currentDate, now);
    }
    return false;
  };
  var handlePast = function handlePast(date, paging) {
    if (!allowPastDates && paging) {
      return date;
    }
    if (!allowPastDates && initialDate && beforeDate(date, now) && !todayDate(date)) {
      return now;
    }
    if (!allowPastDates && !initialDate && beforeDate(date, now) && !todayDate(date)) {
      return currentDate;
    }
    return date;
  };
  var handlePreviousDay = function handlePreviousDay() {
    return setCurrentDate(handlePast(subDay(currentDate)));
  };
  var handlePreviousMonth = function handlePreviousMonth(paging) {
    return setCurrentDate(handlePast(subMonth(currentDate), paging));
  };
  var handlePreviousWeek = function handlePreviousWeek() {
    return setCurrentDate(handlePast(subWeek(currentDate)));
  };
  var handlePreviousYear = function handlePreviousYear() {
    return setCurrentDate(handlePast(subYear(currentDate)));
  };
  var handleWeekEnd = function handleWeekEnd() {
    return setCurrentDate(endWeek(currentDate));
  };
  var handleWeekStart = function handleWeekStart() {
    return setCurrentDate(handlePast(startWeek(currentDate)));
  };
  var handleDate = function handleDate(maybeDate, callback) {
    var checkPastDate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var _validateDate = validateDate(locale.inputFormat.format, maybeDate),
      date = _validateDate.date,
      dateValue = _validateDate.dateValue,
      valid = _validateDate.valid;
    if (valid) {
      if (checkPastDate && !allowPastDates && beforeDate(date, now) && !todayDate(date)) {
        setInternalError(pastDateError);
      } else {
        setCurrentDate(date);
        setInternalError('');
        setSelectedDate(date);
        setValue(dateValue);
        if (callback) {
          callback(date);
        }
      }
    } else {
      setInternalError(invalidDateError);
    }
  };
  var handleSelectedDate = function handleSelectedDate(date) {
    handleDate(date, onSelection);
    if (closeOnSelection) handleClose();
  };
  var handleInputDate = function handleInputDate(e) {
    if (e.target.value) {
      handleDate(e.target.value, onSelection);
    } else {
      // user cleared their typed date, reset error
      setInternalError('');
    }
  };
  var handleSelectedDateKeyDown = function handleSelectedDateKeyDown(e) {
    var key = e.key,
      shiftKey = e.shiftKey;
    switch (key) {
      case 'Enter':
        {
          handleSelectedDate(currentDate);
          break;
        }
      case 'Escape':
        {
          handleClose();
          break;
        }
      case ' ':
        {
          handleSelectedDate(currentDate);
          break;
        }
      case 'PageUp':
        {
          e.preventDefault();
          if (shiftKey) {
            handlePreviousYear();
          } else {
            handlePreviousMonth();
          }
          break;
        }
      case 'PageDown':
        {
          e.preventDefault();
          if (shiftKey) {
            handleNextYear();
          } else {
            handleNextMonth();
          }
          break;
        }
      case 'End':
        {
          e.preventDefault();
          handleWeekEnd();
          break;
        }
      case 'Home':
        {
          e.preventDefault();
          handleWeekStart();
          break;
        }
      case 'ArrowLeft':
        {
          e.preventDefault();
          handlePreviousDay();
          break;
        }
      case 'ArrowUp':
        {
          e.preventDefault();
          handlePreviousWeek();
          break;
        }
      case 'ArrowRight':
        {
          e.preventDefault();
          handleNextDay();
          break;
        }
      case 'ArrowDown':
        {
          e.preventDefault();
          handleNextWeek();
          break;
        }
    }
  };
  var createCalendar = function createCalendar() {
    setCalendar(generateCalendar(currentDate));
    setColumns(generateColumns(now, locale.locale));
  };
  useEffect(function () {
    setMounted(true);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      setInitialDate(convertToDate(defaultSelectedDate, locale.inputFormat.format));
    }
  }, [defaultSelectedDate]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (initialDate) {
      handleDate(initialDate, undefined, false);
    }
  }, [initialDate]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (open) {
      // initial calendar render on open
      createCalendar();
    }
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      setLocale(getInputFormatLocale(defaultLocale));
    }
  }, [defaultLocale]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      // the calendar displays different between locales
      createCalendar();
    }
  }, [locale]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      // needs to rerun when going from month to month
      createCalendar();
    }
  }, [currentDate]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      var _currentDateRef$curre;
      // focus on the current date when the calendar changes
      (_currentDateRef$curre = currentDateRef.current) === null || _currentDateRef$curre === void 0 || _currentDateRef$curre.focus();
    }
  }, [calendar]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (mounted) {
      setOpen(defaultOpen || false);
    }
  }, [defaultOpen]); // eslint-disable-line react-hooks/exhaustive-deps
  var _useLayer = useLayer(_objectSpread(_objectSpread({
      auto: true,
      container: getContainer(wrapperId),
      containerOffset: 0,
      overflowContainer: true,
      placement: DatePickerPlacements.BottomStart,
      possiblePlacements: Object.keys(DatePickerPlacements),
      snap: true,
      triggerOffset: 8
    }, useLayerOptions), {}, {
      isOpen: open,
      onOutsideClick: closeOnClickAway ? function () {
        handleClose();
        if (useLayerOptions !== null && useLayerOptions !== void 0 && useLayerOptions.onOutsideClick) useLayerOptions.onOutsideClick();
      } : useLayerOptions === null || useLayerOptions === void 0 ? void 0 : useLayerOptions.onOutsideClick
    })),
    layerProps = _useLayer.layerProps,
    renderLayer = _useLayer.renderLayer,
    triggerProps = _useLayer.triggerProps;
  var layerRef = layerProps.ref,
    layerPropsStyle = layerProps.style,
    otherLayerProps = _objectWithoutProperties(layerProps, _excluded2);
  var renderCalendar = function renderCalendar() {
    return /*#__PURE__*/React.createElement("div", _extends({}, calendarProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__calendar': true
      }, "".concat(calendarProps === null || calendarProps === void 0 ? void 0 : calendarProps.className), !!(calendarProps !== null && calendarProps !== void 0 && calendarProps.className)))
    }), /*#__PURE__*/React.createElement("div", _extends({}, headerProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__header': true
      }, "".concat(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className), !!(headerProps !== null && headerProps !== void 0 && headerProps.className)))
    }), /*#__PURE__*/React.createElement("h6", _extends({}, headingProps, {
      "aria-live": "polite",
      className: classnames(_defineProperty({
        'bf-date-picker__heading': true
      }, "".concat(headingProps === null || headingProps === void 0 ? void 0 : headingProps.className), !!(headingProps !== null && headingProps !== void 0 && headingProps.className))),
      id: headingId
    }), formatDate(currentDate, 'MMMM yyyy', locale.locale)), /*#__PURE__*/React.createElement(IconButton, _extends({}, previousMonthButtonProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__header-button': true,
        'bf-date-picker__previous-month-button': true
      }, "".concat(previousMonthButtonProps === null || previousMonthButtonProps === void 0 ? void 0 : previousMonthButtonProps.className), !!(previousMonthButtonProps !== null && previousMonthButtonProps !== void 0 && previousMonthButtonProps.className))),
      disabled: disablePreviousMonth(),
      icon: FontIcons.CaretLeft,
      label: previousMonthButton,
      look: ButtonLooks.Default,
      onClick: function onClick(e) {
        handlePreviousMonth(true);
        if (previousMonthButtonProps !== null && previousMonthButtonProps !== void 0 && previousMonthButtonProps.onClick) {
          previousMonthButtonProps.onClick(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') handlePreviousMonth(true);
        if (previousMonthButtonProps !== null && previousMonthButtonProps !== void 0 && previousMonthButtonProps.onKeyDown) {
          previousMonthButtonProps.onKeyDown(e);
        }
      }
    })), /*#__PURE__*/React.createElement(IconButton, _extends({}, nextMonthButtonProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__header-button': true,
        'bf-date-picker__next-month-button': true
      }, "".concat(nextMonthButtonProps === null || nextMonthButtonProps === void 0 ? void 0 : nextMonthButtonProps.className), !!(nextMonthButtonProps !== null && nextMonthButtonProps !== void 0 && nextMonthButtonProps.className))),
      icon: FontIcons.CaretRight,
      label: nextMonthButton,
      look: ButtonLooks.Default,
      onClick: function onClick(e) {
        handleNextMonth();
        if (nextMonthButtonProps !== null && nextMonthButtonProps !== void 0 && nextMonthButtonProps.onClick) {
          nextMonthButtonProps.onClick(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') handleNextMonth();
        if (nextMonthButtonProps !== null && nextMonthButtonProps !== void 0 && nextMonthButtonProps.onKeyDown) {
          nextMonthButtonProps.onKeyDown(e);
        }
      }
    })), /*#__PURE__*/React.createElement(CloseButton, _extends({}, closeButtonProps, {
      "aria-label": closeButton,
      className: classnames(_defineProperty({
        'bf-date-picker__header-button': true,
        'bf-date-picker__close-button': true,
        'bf-date-picker__close-button--hidden': !showCloseButton
      }, "".concat(closeButtonProps === null || closeButtonProps === void 0 ? void 0 : closeButtonProps.className), !!(closeButtonProps !== null && closeButtonProps !== void 0 && closeButtonProps.className))),
      onClick: function onClick(e) {
        handleClose();
        if (closeButtonProps !== null && closeButtonProps !== void 0 && closeButtonProps.onClick) {
          closeButtonProps.onClick(e);
        }
      },
      onKeyDown: function onKeyDown(e) {
        if (e.key === 'Enter') handleClose();
        if (closeButtonProps !== null && closeButtonProps !== void 0 && closeButtonProps.onKeyDown) {
          closeButtonProps.onKeyDown(e);
        }
      }
    }))), /*#__PURE__*/React.createElement("table", _extends({}, gridProps, {
      "aria-labelledby": headingId,
      className: classnames(_defineProperty({
        'bf-date-picker__grid': true
      }, "".concat(gridProps === null || gridProps === void 0 ? void 0 : gridProps.className), !!(gridProps !== null && gridProps !== void 0 && gridProps.className))),
      role: "grid"
    }), /*#__PURE__*/React.createElement("thead", _extends({}, theadProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__thead': true
      }, "".concat(theadProps === null || theadProps === void 0 ? void 0 : theadProps.className), !!(theadProps !== null && theadProps !== void 0 && theadProps.className)))
    }), /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__row': true
      }, "".concat(rowProps === null || rowProps === void 0 ? void 0 : rowProps.className), !!(rowProps !== null && rowProps !== void 0 && rowProps.className)))
    }), columns.map(function (column) {
      return /*#__PURE__*/React.createElement(BaseColumnHeader, _extends({}, columnHeaderProps, {
        column: column,
        key: column.abbr
      }));
    }))), /*#__PURE__*/React.createElement("tbody", _extends({}, tbodyProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__tbody': true
      }, "".concat(tbodyProps === null || tbodyProps === void 0 ? void 0 : tbodyProps.className), !!(tbodyProps !== null && tbodyProps !== void 0 && tbodyProps.className)))
    }), calendar && calendar.map(function (week, w) {
      return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
        className: classnames(_defineProperty({
          'bf-date-picker__row': true
        }, "".concat(rowProps === null || rowProps === void 0 ? void 0 : rowProps.className), !!(rowProps !== null && rowProps !== void 0 && rowProps.className))),
        key: "".concat(id, "-week-").concat(w),
        role: "row"
      }), week.map(function (day, d) {
        var key = "".concat(id, "-week-").concat(w, "-day-").concat(d);
        if (!day) {
          return /*#__PURE__*/React.createElement(BaseGridCell, {
            key: key
          });
        }
        var today = todayDate(day);
        var isBeforeToday = beforeDate(day, now);
        var isCurrentDate = sameDay(currentDate, day);
        var isInitialDate = initialDate ? sameDay(initialDate, day) : false;
        var isDisabled = !isInitialDate && !allowPastDates && isBeforeToday && !today;
        var isSelectedDate = !!selectedDate && sameDay(selectedDate, day);
        return /*#__PURE__*/React.createElement(BaseGridCell, _extends({}, gridCellProps, {
          "aria-disabled": isDisabled,
          "aria-selected": isSelectedDate,
          key: key,
          onClick: isDisabled ? undefined : function () {
            return handleSelectedDate(day);
          },
          onKeyDown: isDisabled ? undefined : function (e) {
            return handleSelectedDateKeyDown(e);
          },
          ref: isCurrentDate ? currentDateRef : undefined,
          tabIndex: isCurrentDate ? 0 : -1,
          title: formatDate(day, 'eeee, MMMM d, yyyy', locale.locale)
        }), formatDate(day, 'd', locale.locale), today && /*#__PURE__*/React.createElement("span", _extends({}, todayProps, {
          "aria-hidden": true,
          className: classnames(_defineProperty({
            'bf-date-picker__today': true
          }, "".concat(todayProps === null || todayProps === void 0 ? void 0 : todayProps.className), !!(todayProps !== null && todayProps !== void 0 && todayProps.className))),
          role: "img"
        })));
      }));
    }))));
  };
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames13 = {
      'bf-date-picker': true,
      'bf-date-picker--disabled': disabled,
      'bf-date-picker--error': hasError,
      'bf-date-picker--help-text': hasHelpText
    }, _defineProperty(_classnames13, "bf-date-picker--label-".concat(labelPosition), showLabel), _defineProperty(_classnames13, 'bf-date-picker--label-hidden', !showLabel), _defineProperty(_classnames13, "bf-date-picker--look-".concat(look), look), _defineProperty(_classnames13, 'bf-date-picker--readonly', readOnly), _defineProperty(_classnames13, 'bf-date-picker--required', hasRequired), _defineProperty(_classnames13, "".concat(className), !!className), _classnames13)),
    id: wrapperId,
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    error: error,
    errorPosition: errorPosition,
    errorProps: errorProps,
    htmlFor: id,
    inlineAlertId: inlineAlertId,
    label: label,
    labelPosition: labelPosition,
    labelProps: labelProps,
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, triggerProps, {
    disabled: disabled,
    error: error,
    errorPosition: errorPosition,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpTextId,
    helpTextProps: helpTextProps,
    inlineAlertId: inlineAlertId,
    labelPosition: labelPosition,
    look: look
  }), /*#__PURE__*/React.createElement(TextfieldInner, _extends({}, innerProps), /*#__PURE__*/React.createElement(BaseTextfield, _extends({}, textfieldProps, {
    "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    "aria-invalid": hasError,
    className: classnames(_defineProperty({
      'bf-date-picker__textfield': true
    }, "".concat(textfieldProps === null || textfieldProps === void 0 ? void 0 : textfieldProps.className), !!(textfieldProps !== null && textfieldProps !== void 0 && textfieldProps.className))),
    disabled: disabled,
    id: id,
    max: max,
    maxLength: maxLength,
    min: min,
    minLength: minLength,
    name: name,
    onBlur: function onBlur(e) {
      handleInputDate(e);
      if (_onBlur) _onBlur(e);
    },
    onChange: function onChange(e) {
      setValue(e.target.value);
      if (_onChange) _onChange(e);
    },
    onFocus: function onFocus(e) {
      handleClose(false);
      if (textfieldProps !== null && textfieldProps !== void 0 && textfieldProps.onFocus) {
        textfieldProps.onFocus(e);
      }
    },
    pattern: pattern,
    placeholder: locale.inputFormat.placeholder,
    readOnly: readOnly,
    ref: ref,
    required: required,
    value: value
  })), /*#__PURE__*/React.createElement(IconButton, _extends({}, calendarIconButtonProps, {
    className: classnames(_defineProperty({
      'bf-date-picker__calendar-icon-button': true
    }, "".concat(calendarIconButtonProps === null || calendarIconButtonProps === void 0 ? void 0 : calendarIconButtonProps.className), !!(calendarIconButtonProps !== null && calendarIconButtonProps !== void 0 && calendarIconButtonProps.className))),
    disabled: disabled || readOnly,
    icon: FontIcons.Calendar,
    id: calendarIconButtonId,
    label: selectedDate ? "".concat(changeDate, " ").concat(formatDate(selectedDate, 'eeee, MMMM d, yyyy', locale.locale)) : chooseDate,
    look: ButtonLooks.Default,
    onClick: function onClick(e) {
      open ? handleClose() : handleOpen();
      if (calendarIconButtonProps !== null && calendarIconButtonProps !== void 0 && calendarIconButtonProps.onClick) {
        calendarIconButtonProps.onClick(e);
      }
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === 'Enter') open ? handleClose() : handleOpen();
      if (calendarIconButtonProps !== null && calendarIconButtonProps !== void 0 && calendarIconButtonProps.onKeyDown) {
        calendarIconButtonProps.onKeyDown(e);
      }
    },
    ref: calendarIconButtonRef
  })))), renderLayer( /*#__PURE__*/React.createElement(Transition, {
    appear: open,
    in: open,
    mountOnEnter: true,
    timeout: timeout,
    unmountOnExit: true
  }, function (transitionStatus) {
    return /*#__PURE__*/React.createElement("div", _extends({}, dialogProps, otherLayerProps, {
      "aria-label": chooseDate,
      "aria-modal": true,
      className: classnames(_defineProperty({
        'bf-date-picker__dialog': true
      }, "".concat(dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.className), !!(dialogProps !== null && dialogProps !== void 0 && dialogProps.className))),
      id: dialogId,
      ref: mergeRefs([nodeRef, layerRef]),
      role: "dialog",
      style: _objectSpread(_objectSpread(_objectSpread({}, dialogProps === null || dialogProps === void 0 ? void 0 : dialogProps.style), layerPropsStyle), !prefersReducedMotion && transitionDuration > 0 && transitionFadeIn({
        transitionDelay: transitionDelay,
        transitionDuration: transitionDuration,
        transitionStatus: transitionStatus
      }))
    }), focusLock ? /*#__PURE__*/React.createElement(FocusLock, _extends({}, focusLockProps, {
      className: classnames(_defineProperty({
        'bf-date-picker__focus-lock': true
      }, "".concat(focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.className), !!(focusLockProps !== null && focusLockProps !== void 0 && focusLockProps.className))),
      // eslint-disable-next-line jsx-a11y/no-autofocus
      autoFocus: (focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.autoFocus) || false,
      crossFrame: (focusLockProps === null || focusLockProps === void 0 ? void 0 : focusLockProps.crossFrame) || false
    }), renderCalendar()) : renderCalendar());
  })));
});
export { BaseDatePicker };